<template>
  <svg
    v-if="!props.active"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.76668 8.14622L2.20128 13.6766C1.7521 15.5917 2.78494 17.5446 4.62073 18.2513C6.4237 18.9453 8.46388 18.229 9.43733 16.5603L9.57313 16.3275C9.76376 16.0007 10.1136 15.7997 10.492 15.7997H13.5348C13.9132 15.7997 14.263 16.0007 14.4537 16.3275L14.5893 16.56C15.5628 18.2289 17.6032 18.9453 19.4064 18.2512C21.2422 17.5445 22.2752 15.5918 21.8264 13.6766L20.2351 8.14863C19.5852 5.37548 16.3555 4.11677 14 5.71819C12.8912 6.65394 11.3771 6.65391 10 5.71726C7.64548 4.11585 4.41689 5.37394 3.76668 8.14622Z"
      stroke="#333333"
      stroke-width="1.5" />
    <path
      d="M7.74869 8.79293L7.74869 13.0578M9.88113 10.9254H5.61625"
      stroke="#4D4D4D"
      stroke-width="1.5" />
    <path
      d="M16.917 9.47559C16.917 9.49993 16.9376 9.52051 16.9619 9.52051C16.9861 9.52029 17.0059 9.49979 17.0059 9.47559C17.0056 9.45157 16.9859 9.43186 16.9619 9.43164C16.9377 9.43164 16.9172 9.45143 16.917 9.47559Z"
      fill="#4D4D4D"
      stroke="#4D4D4D"
      stroke-width="1.4542" />
    <path
      d="M15.1675 11.3096C15.1675 11.3339 15.1881 11.3545 15.2124 11.3545C15.2365 11.3543 15.2563 11.3338 15.2563 11.3096C15.2561 11.2856 15.2364 11.2659 15.2124 11.2656C15.1882 11.2656 15.1677 11.2854 15.1675 11.3096Z"
      fill="#4D4D4D"
      stroke="#4D4D4D"
      stroke-width="1.4542" />
  </svg>
  <svg
    v-else
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.85719 8.35492L2.85773 14.3703C2.59797 15.9337 3.4186 17.4771 4.85997 18.136L5.39368 18.38C6.73041 18.991 8.3127 18.4895 9.05328 17.2199C9.56584 16.3412 10.5065 15.8009 11.5238 15.8009H12.5031C13.5203 15.8009 14.461 16.3412 14.9736 17.2199C15.7142 18.4895 17.2964 18.9911 18.6332 18.38L19.1672 18.1359C20.6086 17.477 21.4293 15.9337 21.1699 14.3703L20.1718 8.35671C19.7099 5.57414 16.5188 4.20803 14.1862 5.7939C12.875 6.68534 11.1521 6.68531 9.84111 5.79362C7.50946 4.20775 4.31938 5.57321 3.85719 8.35492Z"
      fill="url(#paint0_linear_3913_10162)" />
    <path
      d="M3.76668 8.14622L2.20128 13.6766C1.7521 15.5917 2.78494 17.5446 4.62073 18.2513C6.4237 18.9453 8.46388 18.229 9.43733 16.5603L9.57313 16.3275C9.76376 16.0007 10.1136 15.7997 10.492 15.7997H13.5348C13.9132 15.7997 14.263 16.0007 14.4537 16.3275L14.5893 16.56C15.5628 18.2289 17.6032 18.9453 19.4064 18.2512C21.2422 17.5445 22.2752 15.5918 21.8264 13.6766L20.2351 8.14863C19.5852 5.37548 16.3555 4.11677 14 5.71819C12.8912 6.65394 11.3771 6.65391 10 5.71726C7.64548 4.11585 4.41689 5.37394 3.76668 8.14622Z"
      stroke="url(#paint1_linear_3913_10162)"
      stroke-width="1.5"
      stroke-linejoin="round" />
    <path
      d="M7.74869 8.79293L7.74869 13.0578M9.88113 10.9254H5.61625"
      stroke="white"
      stroke-width="1.5" />
    <circle cx="2.65704" cy="2.63653" r="1.06622" fill="url(#paint2_linear_3913_10162)" />
    <circle
      cx="20.9338"
      cy="3.85333"
      r="1.06622"
      transform="rotate(90 20.9338 3.85333)"
      fill="url(#paint3_linear_3913_10162)" />
    <ellipse
      cx="1.06622"
      cy="1.06622"
      rx="1.06622"
      ry="1.06622"
      transform="matrix(1 8.74228e-08 8.74228e-08 -1 8.81494 22.6543)"
      fill="url(#paint4_linear_3913_10162)" />
    <g filter="url(#filter0_d_3913_10162)">
      <path
        d="M16.2785 9.476C16.2785 9.85322 16.5843 10.159 16.9615 10.159C17.3387 10.159 17.6445 9.85322 17.6445 9.476C17.6445 9.09877 17.3387 8.79297 16.9615 8.79297C16.5843 8.79297 16.2785 9.09877 16.2785 9.476Z"
        fill="white" />
      <path
        d="M16.917 9.47559C16.917 9.49993 16.9376 9.52051 16.9619 9.52051C16.9861 9.52029 17.0059 9.49979 17.0059 9.47559C17.0056 9.45157 16.9859 9.43186 16.9619 9.43164C16.9377 9.43164 16.9172 9.45143 16.917 9.47559Z"
        stroke="white"
        stroke-width="1.4542" />
    </g>
    <g filter="url(#filter1_d_3913_10162)">
      <path
        d="M14.5289 11.31C14.5289 11.6872 14.8347 11.993 15.212 11.993C15.5892 11.993 15.895 11.6872 15.895 11.31C15.895 10.9328 15.5892 10.627 15.212 10.627C14.8347 10.627 14.5289 10.9328 14.5289 11.31Z"
        fill="white" />
      <path
        d="M15.1675 11.3096C15.1675 11.3339 15.1881 11.3545 15.2124 11.3545C15.2365 11.3543 15.2563 11.3338 15.2563 11.3096C15.2561 11.2856 15.2364 11.2659 15.2124 11.2656C15.1882 11.2656 15.1677 11.2854 15.1675 11.3096Z"
        stroke="white"
        stroke-width="1.4542" />
    </g>
    <defs>
      <filter
        id="filter0_d_3913_10162"
        x="13.3699"
        y="5.88457"
        width="7.18301"
        height="7.18203"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1.4542" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3913_10162" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3913_10162"
          result="shape" />
      </filter>
      <filter
        id="filter1_d_3913_10162"
        x="11.6204"
        y="7.71856"
        width="7.18301"
        height="7.18203"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1.4542" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3913_10162" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3913_10162"
          result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_3913_10162"
        x1="12.5476"
        y1="6.66137"
        x2="13.3119"
        y2="22.5667"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3913_10162"
        x1="14.1463"
        y1="-0.603928"
        x2="20.0734"
        y2="24.5561"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#320D57" />
        <stop offset="0.135261" stop-color="#46207D" />
        <stop offset="0.603514" stop-color="#8F42FE" />
        <stop offset="0.875923" stop-color="#C7A1FF" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3913_10162"
        x1="3.72326"
        y1="3.70275"
        x2="2.12393"
        y2="1.57031"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" />
        <stop offset="1" stop-color="#8F43FF" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3913_10162"
        x1="22"
        y1="4.91955"
        x2="20.4007"
        y2="2.78711"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" />
        <stop offset="1" stop-color="#8F43FF" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3913_10162"
        x1="2.13244"
        y1="2.13244"
        x2="0.53311"
        y2="3.59211e-07"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" />
        <stop offset="1" stop-color="#8F43FF" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});
</script>
